<script setup>
import moment from "moment";
import { LayoutDrawer } from "@easy/ui/layouts";

import { AvatarSm } from "@easy/ui/avatars";
import { ButtonSecondaryMd } from "@easy/ui/buttons";
import { ArrowReloadIcon } from "@easy/ui/icons";
import { TableContainer, TableCell } from "@easy/ui/tables";
import { useI18n } from "vue-i18n";
import { computed, ref, watch } from "vue";

const props = defineProps({
    certificate: {
        type: Object,
        required: true,
    },
    isLoading: {
        type: Boolean,
        default: false,
    },
});
const emit = defineEmits(["hide", "regenerate"]);
const { t } = useI18n();
const certificateDetails = computed(() => [
    {
        label: "Id",
        value: props.certificate?.uuid,
    },
    {
        label: t("player.panel.certificates.issued"),
        value: moment(props.certificate?.issueDate).format("DD.MM.YYYY"),
    },
    {
        label: t("shared.first_last_name"),
        value: props.certificate?.fullName,
    },
    {
        label: t("shared.email"),
        value: props.certificate?.student?.email,
    },
]);

const handleRegenerate = () => {
    emit("regenerate", props.certificate);
};

const openDrawer = ref(true);
watch(openDrawer, (value) => {
    if (!value) {
        emit("hide");
    }
});
</script>

<template>
    <LayoutDrawer v-model="openDrawer" size="md" :title="certificate?.fullName">
        <template #before-title>
            <AvatarSm image="" :name="certificate?.fullName" />
        </template>
        <template #drawer>
            <div class="p-6 space-y-5">
                <TableContainer class="-mt-3">
                    <template #body>
                        <tr v-for="item in certificateDetails" :key="item.label">
                            <TableCell>
                                <p class="ct-text-3">
                                    {{ item.label }}
                                </p>
                            </TableCell>
                            <TableCell :wrap-text="true">
                                <span>{{ item.value }}</span>
                            </TableCell>
                        </tr>
                    </template>
                </TableContainer>
                <ButtonSecondaryMd @click="handleRegenerate" class="w-full" :loading="isLoading">
                    <ArrowReloadIcon />
                    <span>{{ $t("player.certificates.regenerate") }}</span>
                </ButtonSecondaryMd>
            </div>
        </template>
    </LayoutDrawer>
</template>
